import Image from "next/image"
import styles from "./ArticleList.module.css"
import { transformCloudinaryURL } from "../../../utils/imageUtils"
import { StringToESDate } from "../../../utils/dateUtils"
import { Col, Row, Tooltip } from "antd"
import { ArticleProps } from "../../../interfaces/props.interface"
import Link from "next/link"

const ArticleList = ({ articles }: { articles: ArticleProps[] }) => (
  <Row gutter={[16, 80]}>
    {articles?.map(({ title, small_image, date, slug }: any, idx: number) => (
      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 24 }}
        xl={{ span: 12 }}
        xxl={{ span: 8 }}
        key={idx}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Link href={`/articulo/${slug}`} passHref>
          <a>
            <div className={styles.cardWrap}>
              <div className={styles.imageWrapper}>
                <Image
                  alt={title}
                  src={transformCloudinaryURL(small_image)}
                  className={styles.cardImage}
                  layout="fill"
                />
                <img
                  alt="Decorative overlay"
                  src="/icons/corner-blue.png"
                  className={styles.overlayImage}
                />
              </div>
              <div className={styles.textWrap}>
                <Tooltip title={title} mouseEnterDelay={1}>
                  <p className={styles.cardTitle}>{title}</p>
                </Tooltip>
                <p className={styles.text}>{StringToESDate(date)}</p>
                <p
                  style={{
                    color: "var(--fiva-color)",
                    textDecoration: "underline 2px",
                  }}
                  className={styles.text}
                >
                  Leer más
                </p>
              </div>
            </div>
          </a>
        </Link>
      </Col>
    ))}
  </Row>
)

export default ArticleList
